import { useState } from "react";
import { toast } from "sonner";
import { Languages, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const SpanishFields = ({ fields, source, value = {}, onChange, testId = "es" }) => {
  const [busy, setBusy] = useState(false);
  const set = (k, v) => onChange({ ...value, [k]: v });

  const translate = async () => {
    setBusy(true);
    try {
      const payload = Object.fromEntries(fields.map((f) => [f.key, f.type === "lines" ? (source[f.key] || []).filter(Boolean) : source[f.key]]));
      const { data } = await api.post("/admin/translate", { fields: payload });
      onChange({ ...value, ...data });
      toast.success("Spanish translation ready — review and save");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5 rounded-2xl border border-sage/60 bg-white p-6 sm:p-8" data-testid={`${testId}-section`}>
      <div className="flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
        <div>
          <h2 className="text-xl font-black text-forest">Español (Spanish version)</h2>
          <p className="mt-1 text-xs font-medium text-moss">Auto-translated by AI about 30 seconds after you save. Edit any text below to override it.</p>
        </div>
        <button type="button" onClick={translate} disabled={busy} className="btn-outline !py-2" data-testid={`${testId}-translate-now`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Languages className="h-4 w-4" />} Translate now
        </button>
      </div>
      {fields.map((f) => (
        <div key={f.key} className="space-y-2">
          <Label className="font-bold text-ink">{f.label}</Label>
          {f.type === "input" ? (
            <Input value={value[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} data-testid={`${testId}-${f.key}`} />
          ) : (
            <Textarea rows={f.rows || 3} value={f.type === "lines" ? (value[f.key] || []).join("\n") : value[f.key] || ""}
              onChange={(e) => set(f.key, f.type === "lines" ? e.target.value.split("\n") : e.target.value)} data-testid={`${testId}-${f.key}`} />
          )}
        </div>
      ))}
    </div>
  );
};

export const cleanEs = (es = {}) =>
  Object.fromEntries(Object.entries(es).map(([k, v]) => [k, Array.isArray(v) ? v.map((s) => s.trim()).filter(Boolean) : v]));
